import { Skeleton } from '@berky/ui'

/** Match the dashboard's header, application groups and two information panels. */
export function HomeLoading() {
  return (
    <div role="status" aria-label="Inhalte werden geladen" className="space-y-7">
      <span className="sr-only">Inhalte werden geladen</span>
      <div aria-hidden="true" className="flex flex-col justify-between gap-6 sm:flex-row">
        <div className="space-y-3">
          <Skeleton className="h-8 w-60 max-w-full" />
          <Skeleton className="h-4 w-48" />
        </div>
        <div className="space-y-2">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-14 w-72 max-w-full rounded-lg" />
        </div>
      </div>
      <div
        aria-hidden="true"
        className="grid grid-cols-[minmax(0,1fr)] items-start gap-6 xl:grid-cols-[minmax(0,1fr)_26rem]"
      >
        <div className="space-y-3">
          {[0, 1, 2].map((group) => (
            <div key={group} className="space-y-4 rounded-xl border p-4">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-3 w-2/3" />
              <div className="grid gap-3 sm:grid-cols-2">
                {[0, 1].map((tile) => (
                  <Skeleton key={tile} className="h-28 rounded-lg" />
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-1">
          {[0, 1].map((panel) => (
            <Skeleton key={panel} className="h-64 rounded-xl" />
          ))}
        </div>
      </div>
    </div>
  )
}
